import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PresetCard } from '@/components/PresetCard';
import { PRESETS_BY_LEVEL } from '@/data/presets';

const order = ['Beginner', 'Intermediate', 'Advanced'];

export const Presets = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-7">
      <header>
        <p className="text-sm font-medium text-[#CBD5E1]">Choose your intensity</p>
        <h1 className="mt-1 text-3xl font-extrabold text-white sm:text-4xl">
          Presets
        </h1>
      </header>

      {order.map((level) => (
        <section key={level}>
          <h2 className="mb-3 text-lg font-bold text-white">{level}</h2>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {PRESETS_BY_LEVEL[level].map((preset, i) => (
              <motion.div
                key={preset.id}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
              >
                <PresetCard
                  preset={preset}
                  onStart={() => navigate(`/workout/${preset.id}`)}
                  testId={`preset-${preset.id}`}
                />
              </motion.div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default Presets;
